import { CloseOutlined } from "@ant-design/icons";
import { Button, Drawer, Switch } from "antd";
import { m } from "framer-motion";
import { type CSSProperties, useState } from "react";
import screenfull from "screenfull";
import CyanBlur from "@/assets/images/background/cyan-blur.png";
import RedBlur from "@/assets/images/background/red-blur.png";
import { varHover } from "@/components/animate/variants/action";
import { IconButton, SvgIcon } from "@/components/icon";
import { useSettingActions, useSettings } from "@/store/settingStore";
import { themeVars } from "@/theme/theme.css";
import { useDispatch, useSelector } from "react-redux";
import { setColorTheme, setCustomPalette } from "@/store/colorThemeSlice";

/**
 * App Setting
 */
export default function SettingButton() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Custom Theme modal state
  const [customThemeOpen, setCustomThemeOpen] = useState(false);
  const [draftColors, setDraftColors] = useState<string[]>([]);
  const themeColorPallete = useSelector(state => state.themeColorPalete.themeColorPalete);
  const selectedColorName = useSelector(state => state.themeColorPalete.selectedColorName);
  const dispatch = useDispatch();
  // Replace all direct usage of 'settings' with this hook
  const settings = useSettings();
  const {
    
    
    
    // [S1854 removed] // [S1854 removed] themeStretch,
    // [S1854 removed] // [S1854 removed] breadCrumb,
    // [S1854 removed] // [S1854 removed] multiTab,
    // [S1854 removed] // [S1854 removed] darkSidebar,
    
    // [S1854 removed] // [S1854 removed] fontFamily,
    showChartGridLines,
    showChartVerticalGridLines
  } = settings;
  const {
    setSettings
  } = useSettingActions();
  const setShowChartGridLines = (checked: boolean) => {
    setSettings({
      ...settings,
      showChartGridLines: checked
    });
  };
  const setShowChartVerticalGridLines = (checked: boolean) => {
    setSettings({
      ...settings,
      showChartVerticalGridLines: checked
    });
  };

  // const themeColorPallete = useSelector((state)=>state.themeColorPalete.themeColorPalete)
  // const dispatch = useDispatch();

  const style: CSSProperties = {
    backdropFilter: "blur(20px)",
    backgroundImage: `url("${CyanBlur}"), url("${RedBlur}")`,
    backgroundRepeat: "no-repeat, no-repeat",
    backgroundColor: `rgba(${themeVars.colors.background.paperChannel}, 0.9)`,
    backgroundPosition: "right top, left bottom",
    backgroundSize: "50, 50%"
  };
  const [isFullscreen, setIsFullscreen] = useState(screenfull.isFullscreen);
  const toggleFullScreen = () => {
    if (screenfull.isEnabled) {
      screenfull.toggle();
      setIsFullscreen(!isFullscreen);
    }
  };
  return <>
			<div className="flex items-center justify-center overflow-hidden mr-4">
				<m.div
      // animate={{
      // 	rotate: [0, drawerOpen ? 0 : 360],
      // }}
      // transition={{
      // 	duration: 12,
      // 	ease: "linear",
      // 	repeat: Number.POSITIVE_INFINITY,
      // }}
      whileTap="tap" whileHover="hover" variants={varHover(1.05)} onClick={() => setDrawerOpen(true)}>
          
					<IconButton className="h-10 w-10">
						{/* <SvgIcon icon="ic-setting" size="24" /> */}
						<svg width="24" height="28" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.39575 20L7.93742 17.625C7.61797 17.5 7.30895 17.3542 7.01034 17.1875C6.71172 17.0208 6.43047 16.8264 6.16659 16.6042L3.87492 17.375L2.27075 14.6042L4.08325 13.0208C4.05547 12.8542 4.03464 12.6875 4.02075 12.5208C4.00686 12.3542 3.99992 12.1806 3.99992 12C3.99992 11.8194 4.00686 11.6458 4.02075 11.4792C4.03464 11.3125 4.05547 11.1458 4.08325 10.9792L2.27075 9.39583L3.87492 6.625L6.16659 7.39583C6.43047 7.17361 6.71172 6.97917 7.01034 6.8125C7.30895 6.64583 7.61797 6.5 7.93742 6.375L8.39575 4H11.6041L12.0624 6.375C12.3819 6.5 12.6909 6.64583 12.9895 6.8125C13.2881 6.97917 13.5694 7.17361 13.8333 7.39583L16.1249 6.625L17.7291 9.39583L15.9166 10.9792C15.9444 11.1458 15.9652 11.3125 15.9791 11.4792C15.993 11.6458 15.9999 11.8194 15.9999 12C15.9999 12.1806 15.993 12.3542 15.9791 12.5208C15.9652 12.6875 15.9444 12.8542 15.9166 13.0208L17.7291 14.6042L16.1249 17.375L13.8333 16.6042C13.5694 16.8264 13.2881 17.0208 12.9895 17.1875C12.6909 17.3542 12.3819 17.5 12.0624 17.625L11.6041 20H8.39575ZM9.62492 18.5H10.3749L10.7708 16.4375C11.2985 16.3403 11.7916 16.1597 12.2499 15.8958C12.7083 15.6319 13.1041 15.2986 13.4374 14.8958L15.4374 15.5625L15.8124 14.9375L14.2291 13.5417C14.3124 13.3056 14.3784 13.059 14.427 12.8021C14.4756 12.5451 14.4999 12.2778 14.4999 12C14.4999 11.7222 14.4756 11.4549 14.427 11.1979C14.3784 10.941 14.3124 10.6944 14.2291 10.4583L15.8124 9.0625L15.4374 8.4375L13.4374 9.10417C13.1041 8.70139 12.7083 8.36806 12.2499 8.10417C11.7916 7.84028 11.2985 7.65972 10.7708 7.5625L10.3749 5.5H9.62492L9.22909 7.5625C8.70131 7.65972 8.20825 7.84028 7.74992 8.10417C7.29159 8.36806 6.89575 8.70139 6.56242 9.10417L4.56242 8.4375L4.18742 9.0625L5.77075 10.4583C5.68742 10.6944 5.62145 10.941 5.57284 11.1979C5.52422 11.4549 5.49992 11.7222 5.49992 12C5.49992 12.2778 5.52422 12.5451 5.57284 12.8021C5.62145 13.059 5.68742 13.3056 5.77075 13.5417L4.18742 14.9375L4.56242 15.5625L6.56242 14.8958C6.89575 15.2986 7.29159 15.6319 7.74992 15.8958C8.20825 16.1597 8.70131 16.3403 9.22909 16.4375L9.62492 18.5ZM9.99992 15C10.8333 15 11.5416 14.7083 12.1249 14.125C12.7083 13.5417 12.9999 12.8333 12.9999 12C12.9999 11.1667 12.7083 10.4583 12.1249 9.875C11.5416 9.29167 10.8333 9 9.99992 9C9.16659 9 8.45825 9.29167 7.87492 9.875C7.29159 10.4583 6.99992 11.1667 6.99992 12C6.99992 12.8333 7.29159 13.5417 7.87492 14.125C8.45825 14.7083 9.16659 15 9.99992 15Z" fill="#94A3B8" />
</svg>

					</IconButton>
				</m.div>
			</div>
			<Drawer placement="right" title="Settings" onClose={() => setDrawerOpen(false)} open={drawerOpen} closable={false} styles={{
      body: {
        padding: 0
      },
      mask: {
        backgroundColor: "transparent"
      }
    }} style={style} extra={<IconButton onClick={() => setDrawerOpen(false)} className="h-9 w-9 hover:scale-105">
						<CloseOutlined className="text-gray-400" />
					</IconButton>} footer={<Button type="dashed" block size="large" onClick={toggleFullScreen}>
						<div className="flex items-center justify-center">
							{isFullscreen ? <>
									<SvgIcon icon="ic-settings-exit-fullscreen" color={themeVars.colors.palette.primary.default} className="!m-0" />
              
									<span className="ml-2">Exit FullScreen</span>
								</> : <>
									<SvgIcon icon="ic-settings-fullscreen" className="!m-0" />
									<span className="ml-2 text-gray">FullScreen</span>
								</>}
						</div>
					</Button>}>
        
				<div className="flex flex-col gap-6 p-6">
					{/* theme mode - hidden per user request */}
					{/*
                  <div>
                  <div className="mb-3 text-base font-semibold text-text-secondary">Mode</div>
                  <div className="flex flex-row gap-4">
                  	<Card
                  		onClick={() => setThemeMode(ThemeMode.Light)}
                  		className="flex h-20 w-full cursor-pointer items-center justify-center"
                  	>
                  		<SvgIcon
                  			icon="ic-settings-mode-sun"
                  			size="24"
                  			color={themeMode === ThemeMode.Light ? themeVars.colors.palette.primary.default : ""}
                  		/>
                  	</Card>
                  	<Card
                  		onClick={() => setThemeMode(ThemeMode.Dark)}
                  		className="flex h-20 w-full cursor-pointer items-center justify-center"
                  	>
                  		<SvgIcon
                  			icon="ic-settings-mode-moon"
                  			size="24"
                  			color={themeMode === ThemeMode.Dark ? themeVars.colors.palette.primary.default : ""}
                  		/>
                  	</Card>
                  </div>
                  </div>
                  */}

					{/* theme layout - hidden per user request */}
					{/*
                  <div>
                  <div className="mb-3 text-base font-semibold text-text-secondary">Layout</div>
                  <div className="grid grid-cols-3 gap-4">
                  	<Card
                  		onClick={() => setThemeLayout(ThemeLayout.Vertical)}
                  		className="h-16 cursor-pointer"
                  		style={{ flexGrow: 1, flexShrink: 0 }}
                  		styles={{
                  			body: {
                  				padding: 0,
                  				display: "flex",
                  				justifyContent: "center",
                  				alignItems: "center",
                  				height: "100%",
                  			},
                  		}}
                  	>
                  		<div className="flex h-full w-7 flex-shrink-0 flex-col gap-1 p-1">
                  			<div
                  				className="h-2 w-2 flex-shrink-0 rounded"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Vertical),
                  				}}
                  			/>
                  			<div
                  				className="h-1 w-full flex-shrink-0 rounded opacity-50"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Vertical),
                  				}}
                  			/>
                  			<div
                  				className="h-1 max-w-[12px] flex-shrink-0 rounded opacity-20"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Vertical),
                  				}}
                  			/>
                  		</div>
                  		<div className="h-full w-full flex-1 flex-grow p-1">
                  			<div
                  				className="h-full w-full rounded opacity-20"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Vertical),
                  				}}
                  			/>
                  		</div>
                  	</Card>
                  	<Card
                  		onClick={() => setThemeLayout(ThemeLayout.Horizontal)}
                  		className="h-16 cursor-pointer"
                  		style={{ flexGrow: 1, flexShrink: 0 }}
                  		styles={{
                  			body: {
                  				padding: 0,
                  				display: "flex",
                  				flexDirection: "column",
                  				justifyContent: "center",
                  				alignItems: "center",
                  				height: "100%",
                  			},
                  		}}
                  	>
                  		<div className="flex h-4 w-full items-center gap-1  p-1">
                  			<div
                  				className="h-2 w-2 flex-shrink-0 rounded"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Horizontal),
                  				}}
                  			/>
                  			<div
                  				className="h-1 w-4 flex-shrink-0 rounded opacity-50"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Horizontal),
                  				}}
                  			/>
                  			<div
                  				className="h-1 w-3 flex-shrink-0 rounded opacity-20"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Horizontal),
                  				}}
                  			/>
                  		</div>
                  		<div className="h-full w-full flex-1 flex-grow p-1">
                  			<div
                  				className="h-full w-full rounded opacity-20"
                  				style={{
                  					background: layoutBackground(ThemeLayout.Horizontal),
                  				}}
                  			/>
                  		</div>
                  	</Card>
                  	<Card
                  		onClick={() => setThemeLayout(ThemeLayout.Mini)}
                  		className="h-16 cursor-pointer"
                  		style={{ flexGrow: 1, flexShrink: 0 }}
                  		styles={{
                  			body: {
                  				padding: 0,
                  				display: "flex",
                  				justifyContent: "center",
                  				alignItems: "center",
                  				height: "100%",
                  			},
                  		}}
                  	>
                  		<div className="flex h-full flex-shrink-0 flex-col gap-1 p-1">
                  			<div
                  				className="h-2 w-2 flex-shrink-0 rounded"
                  				style={{ background: layoutBackground(ThemeLayout.Mini) }}
                  			/>
                  			<div
                  				className="h-1 w-full flex-shrink-0 rounded opacity-50"
                  				style={{ background: layoutBackground(ThemeLayout.Mini) }}
                  			/>
                  			<div
                  				className="h-1 max-w-[12px] flex-shrink-0 rounded opacity-20"
                  				style={{ background: layoutBackground(ThemeLayout.Mini) }}
                  			/>
                  		</div>
                  		<div className="h-full w-full flex-1 flex-grow p-1">
                  			<div
                  				className="h-full w-full rounded opacity-20"
                  				style={{ background: layoutBackground(ThemeLayout.Mini) }}
                  			/>
                  		</div>
                  	</Card>
                  </div>
                  </div>
                  */}

					{/* theme stretch */}
					{/* <div>
                  <div className="mb-3 text-base font-semibold text-text-secondary">
                  	<span className="mr-2">Stretch</span>
                  	<Tooltip title="Only available at large resolutions > 1600px (xl)">
                  		<QuestionCircleOutlined />
                  	</Tooltip>
                  </div>
                  		<Card
                  	onClick={() => setThemeStretch(!themeStretch)}
                  	className="flex h-20 w-full cursor-pointer items-center justify-center"
                  	styles={{
                  		body: {
                  			width: "50%",
                  			padding: 0,
                  			display: "flex",
                  			justifyContent: "center",
                  			alignItems: "center",
                  		},
                  	}}
                  >
                  	{themeStretch ? (
                  		<div
                  			className="flex w-full items-center justify-between"
                  			style={{
                  				color: themeVars.colors.palette.primary.default,
                  				transition: "width 300ms 0ms",
                  			}}
                  		>
                  			<LeftOutlined />
                  			<div className="flex flex-grow border-b border-dashed border-border" />
                  			<RightOutlined />
                  		</div>
                  	) : (
                  		<div
                  			className="flex w-1/2 items-center justify-between"
                  			style={{
                  				transition: "width 300ms 0ms",
                  			}}
                  		>
                  			<RightOutlined />
                  			<div className="flex-grow border-b border-dashed border-border" />
                  			<LeftOutlined />
                  		</div>
                  	)}
                  </Card>
                  </div> */
        }

					<div className="space-y-4">
						{/* Main Theme title */}
						<h3 className="text-lg font-medium">Theme</h3>

						{/* Color presets removed per user request */}

						{/* Improved Theme buttons */}
						<div className="grid grid-cols-2 gap-4">
							<Button className={`font-medium rounded-md transition-all ${selectedColorName === "tencolor1" ? "bg-primary-600 text-white shadow-sm" : "bg-gray-100 text-gray-700 hover:bg-gray-200"} py-2 px-4`} onClick={() => dispatch(setColorTheme("tencolor1"))}>
                
								Theme 1
							</Button>
							<Button className={`font-medium rounded-md transition-all ${selectedColorName === "grouped1" ? "bg-primary-600 text-white shadow-sm" : "bg-gray-100 text-gray-700 hover:bg-gray-200"} py-2 px-4`} onClick={() => dispatch(setColorTheme("grouped1"))}>
                
								Theme 2
							</Button>
						</div>
					</div>


					{/* Custom Theme - inline expandable */}
					<div>
						<div className="mb-3 text-base font-semibold text-text-secondary">Custom Theme</div>
						<Button block type={selectedColorName === "custom" ? "primary" : "dashed"} onClick={() => {
            if (!customThemeOpen) {
              const base = selectedColorName === "custom" && Array.isArray(themeColorPallete) && themeColorPallete.length >= 10 ? (themeColorPallete as string[]).slice(0, 10) : ["#6366f1", "#a855f7", "#ec4899", "#14b8a6", "#f59e0b", "#3b82f6", "#10b981", "#f43f5e", "#8b5cf6", "#f97316"];
              setDraftColors(base);
            }
            setCustomThemeOpen(prev => !prev);
          }}>
              
							{"\uD83C\uDFA8"} Custom Theme {customThemeOpen ? "\u25B2" : "\u25BC"}
						</Button>

						{customThemeOpen && <div style={{
            marginTop: 10,
            padding: 14,
            borderRadius: 10,
            border: "1.5px dashed #c7d2fe",
            background: "rgba(99,102,241,0.04)"
          }}>
              
								<div style={{
              fontSize: 11,
              color: "#6b7280",
              marginBottom: 10
            }}>
									Click each circle to pick a chart color
								</div>
								<div style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: "10px 8px",
              marginBottom: 12
            }}>
                
									{draftColors.map((color, idx) => <div key={color?.id || color?._id || color?.key || color?.name || color?.title || color?.label || color?.value || String(color)} style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4
              }}>
                  
											<div style={{
                  width: 38,
                  height: 38,
                  borderRadius: "50%",
                  background: color,
                  border: "3px solid #e5e7eb",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.13)",
                  position: "relative",
                  cursor: "pointer",
                  overflow: "hidden"
                }}>
                    
												<input type="color" value={color} onChange={e => {
                    const updated = [...draftColors];
                    updated[idx] = e.target.value;
                    setDraftColors(updated);
                  }} style={{
                    position: "absolute",
                    inset: 0,
                    opacity: 0,
                    cursor: "pointer",
                    width: "100%",
                    height: "100%"
                  }} title={`Chart Color ${idx + 1}`} />
                    
											</div>
											<span style={{
                  fontSize: 10,
                  color: "#9ca3af",
                  fontWeight: 500
                }}>
												Color {idx + 1}
											</span>
										</div>)}
								</div>
								<div style={{
              display: "flex",
              height: 8,
              borderRadius: 5,
              overflow: "hidden",
              marginBottom: 12,
              gap: 2
            }}>
									{draftColors.map((c, i) => <div key={c?.id || c?._id || c?.key || c?.name || c?.title || c?.label || c?.value || String(c)} style={{
                flex: 1,
                background: c,
                borderRadius: 3
              }} />)}
								</div>
								<Button block type="primary" onClick={() => {
              dispatch(setCustomPalette([...draftColors]));
              setCustomThemeOpen(false);
            }} style={{
              borderRadius: 8
            }}>
                
									Apply Theme
								</Button>
							</div>}
					</div>

					{/* font - hidden per user request */}
					{/*
                  <div>
                  <div className="mb-3 text-base font-semibold text-text-secondary">Font </div>
                  <div className="my-3 text-sm font-semibold text-text-disabled">Family</div>
                  <div className="flex flex-row gap-3">
                  	{Object.entries(FontFamilyPreset).map(([font, family]) => (
                  		<Card
                  			key={font}
                  			className="flex h-20 w-full cursor-pointer items-center justify-center"
                  			onClick={() => setFontFamily(family)}
                  		>
                  			<div
                  				className={cn(
                  					fontFamily === family ? "text-primary font-medium" : "text-text-disabled",
                  					"text-center text-lg",
                  				)}
                  			>
                  				<span>A</span>
                  				<span className="opacity-50 ml-0.5">a</span>
                  			</div>
                  			<span
                  				className={cn(
                  					fontFamily === family ? "text-text-primary font-medium" : "text-text-disabled",
                  					"text-sm",
                  				)}
                  			>
                  				{family.replace("Variable", "")}
                  			</span>
                  		</Card>
                  	))}
                  </div>
                  <div className="my-3 text-sm font-semibold text-text-disabled">Size</div>
                  <Slider min={12} max={20} defaultValue={fontSize} onChange={setFontSize} />
                  </div>
                  */}

					{/* Chart Display Settings */}
					<div>
						<div className="mb-3 text-base font-semibold text-text-secondary">Charts</div>
						<div className="flex flex-col gap-3">
							<div style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								padding: "10px 14px",
								borderRadius: 10,
								border: "1px solid #e2e8f0",
								background: showChartGridLines ? "rgba(99,102,241,0.04)" : "rgba(241,245,249,0.6)",
								transition: "background 0.2s"
							}}>
								<div style={{
									display: "flex",
									flexDirection: "column",
									gap: 2
								}}>
									<span style={{
										fontSize: 13,
										fontWeight: 600,
										color: "#374151"
									}}>Horizontal Grid Lines</span>
									<span style={{
										fontSize: 11,
										color: "#9ca3af"
									}}>
										{showChartGridLines ? "Visible on all charts" : "Hidden on all charts"}
									</span>
								</div>
								<Switch checked={showChartGridLines} onChange={setShowChartGridLines} size="default" />
							</div>

							<div style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								padding: "10px 14px",
								borderRadius: 10,
								border: "1px solid #e2e8f0",
								background: showChartVerticalGridLines ? "rgba(99,102,241,0.04)" : "rgba(241,245,249,0.6)",
								transition: "background 0.2s"
							}}>
								<div style={{
									display: "flex",
									flexDirection: "column",
									gap: 2
								}}>
									<span style={{
										fontSize: 13,
										fontWeight: 600,
										color: "#374151"
									}}>Vertical Grid Lines</span>
									<span style={{
										fontSize: 11,
										color: "#9ca3af"
									}}>
										{showChartVerticalGridLines ? "Visible on all charts" : "Hidden on all charts"}
									</span>
								</div>
								<Switch checked={showChartVerticalGridLines} onChange={setShowChartVerticalGridLines} size="default" />
							</div>
						</div>
					</div>

				</div>
			</Drawer>
		</>;
}